import { Phone } from "lucide-react";

const FOOTER_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Our Work", href: "#gallery" },
  { label: "Maintenance Plans", href: "#plans" },
  { label: "Free Estimate", href: "#estimate" },
  { label: "Contact", href: "#contact" },
];

export default function Footer({ content }) {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-ink text-white py-12 px-4 sm:px-6 lg:px-8 border-t-4 border-brand">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img
            src="/assets/logo.png"
            alt="Somoza's Landscaping, Lawn Care & Tree Service logo"
            className="h-16 w-auto bg-white rounded-md px-2 py-1"
          />
          <p className="mt-4 text-white/70 text-sm leading-relaxed max-w-xs">
            Professional landscaping, lawn care, and tree services for residential
            and commercial properties. Free on-site estimates.
          </p>
        </div>
        <nav aria-label="Footer navigation">
          <h3 className="font-heading font-semibold text-white uppercase tracking-wide text-sm">Explore</h3>
          <ul className="mt-4 grid grid-cols-1 gap-2.5">
            {FOOTER_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-white/70 hover:text-brand transition-colors text-sm"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <h3 className="font-heading font-semibold text-white uppercase tracking-wide text-sm">Contact</h3>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-white/70">
            <li>
              <a href={`tel:${(content?.contact1_phone || "214-576-8224").replace(/[^0-9+]/g, "")}`} className="hover:text-brand transition-colors" data-testid="footer-phone-1">
                {content?.contact1_name || "Jose L. Duran"}: {content?.contact1_phone || "214-576-8224"}
              </a>
            </li>
            <li>
              <a href={`tel:${(content?.contact2_phone || "972-703-3267").replace(/[^0-9+]/g, "")}`} className="hover:text-brand transition-colors" data-testid="footer-phone-2">
                {content?.contact2_name || "Alberto Somoza"}: {content?.contact2_phone || "972-703-3267"}
              </a>
            </li>
            <li>
              <a href={`mailto:${content?.contact1_email || "somozaslandscaping@outlook.com"}`} className="hover:text-brand transition-colors break-all" data-testid="footer-email-1">
                {content?.contact1_email || "somozaslandscaping@outlook.com"}
              </a>
            </li>
            <li>
              <a href={`mailto:${content?.contact2_email || "somozaslandscapingllc@gmail.com"}`} className="hover:text-brand transition-colors break-all" data-testid="footer-email-2">
                {content?.contact2_email || "somozaslandscapingllc@gmail.com"}
              </a>
            </li>
            <li className="text-white/50">{content?.service_area || "Dallas / DFW metro area"}</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-white/50 text-xs">
          © {year} Somoza's Landscaping, Lawn Care &amp; Tree Service. All rights reserved.
        </p>
        <a
          href={`tel:${(content?.contact1_phone || "214-576-8224").replace(/[^0-9+]/g, "")}`}
          data-testid="footer-call-button"
          className="inline-flex items-center gap-2 text-brand font-semibold text-sm hover:text-brand-hover transition-colors"
        >
          <Phone className="w-4 h-4" aria-hidden="true" />
          {content?.contact1_phone || "214-576-8224"}
        </a>
      </div>
    </footer>
  );
}
